import { useAuthStore } from '@/store/authStore/authStore';
import { determinePathType } from '@/utils/determinePathType';
import { useCurrentPath } from '../useCurrentPath/useCurrentPath';
import { useParams } from 'next/navigation';

export const useForbiddenPaths = () => {
    const { pathname, isReady } = useCurrentPath();
    const params = useParams<{ uid?: string }>();
    const uid = params.uid;

    const { isLoggedIn, passwordCheckIsCurrent, sessionCheckIsCurrent } = useAuthStore((state) => ({
        isLoggedIn: state.loggedIn,
        passwordCheckIsCurrent: state.passwordCheckIsCurrent(),
        sessionCheckIsCurrent: state.sessionCheckIsCurrent(),
    }));

    const {
        isPasswordProtectedPath,
        isPrivatePath,
        isUnavailableToLoggedInUsersPath,
        isNotRestrictedPath,
    } = determinePathType(pathname);

    const invalidAttemptToAccessPrivatePath = !isLoggedIn && isPrivatePath;
    const accessingProtectedPathOnExpiredPassword =
        isLoggedIn && isPasswordProtectedPath && !passwordCheckIsCurrent;
    const loggedInUserAccessingUnavailablePath =
        isLoggedIn && isUnavailableToLoggedInUsersPath && !uid;
    const isAllowedToRequestAuthorizedData = isReady && isLoggedIn && sessionCheckIsCurrent;
    const isContentUnavailableToShow =
        invalidAttemptToAccessPrivatePath ||
        accessingProtectedPathOnExpiredPassword ||
        loggedInUserAccessingUnavailablePath;

    return {
        isNotRestrictedPath,
        isContentUnavailableToShow,
        isAllowedToRequestAuthorizedData,
    };
};
